import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['favoriteCheckbox', 'thumb', 'emptyContainer', 'emptyTemplate'];

  /**
   * @param {CustomEvent} event
   */
  remove({ target }) {
    if (this.favoriteCheckboxTarget.checked) {
      target.remove();
    }

    if (this.thumbTargets.length <= 0) {
      this.#displayEmptyTemplate();
    }
  }

  #displayEmptyTemplate() {
    const emptyMsgNode = this.emptyTemplateTarget.content.cloneNode(true);
    this.emptyContainerTarget.appendChild(emptyMsgNode);
  }
}
